// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Swiper from 'swiper';
import './assets/theme.css' // 引入公共样式
import 'swiper/dist/css/swiper.css'; // swiper样式
import animated from 'animate.css'

Vue.config.productionTip = false

Vue.use(animated);

Vue.prototype.$Swiper = Swiper;
Vue.$Swiper = Swiper;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js